import React from "react";

import { LabelProp } from "./types";

import "./styles.scss";

const Label = ({
  label,
  required,
  dynamicContent,
  className,
}: LabelProp): JSX.Element => (
  <div className={`${className ?? ""} label`}>
    {label} {required ? "*" : null}
    {dynamicContent}
  </div>
);

export default Label;
